<template>
<div>
    <div class="box">
        <div class="row">
            <div class="col-md-12">
                <form class="form" v-on:submit.prevent="recordAdvertisement">
                    <fieldset>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-wrap">
                                    <div>
                                        <label for="group_supplier">Advertisement Size</label>
                                        <v-select
                                            label="size_name"
                                            id="adword_size"
                                            :options="advertiseSizes"
                                            index="size_id"
                                            placeholder="Select Advertisement size"
                                            v-model="advertisement.advertisement_size"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label for="payment_date">Placement date</label>
                                        <input id="payment_date" type="date" placeholder="Placement date" v-model="advertisement.placemenet_date" required>
                                    </div>

                                    <div>
                                        <label for="payment_date">Expiry date</label>
                                        <input id="payment_date" type="date" placeholder="Expiry date" v-model="advertisement.expiry_date" required>
                                    </div>
                    
                                    <div>
                                        <label for="payment_date">Artwork deadline</label>
                                        <input id="payment_date" type="date" placeholder="Artwork deadline" v-model="advertisement.submission_deadline_date">
                                    </div>

                                    <div>
                                        <label for="addword_created">Advertisement Created ? </label>
                                        <label class="switch">
                                            <input id="addword_created" type="checkbox" v-model="advertisement.is_graphic_created">
                                            <span class="switch__slider"></span>
                                        </label>  
                                    </div>

                                    <div>
                                        <label for="addword_sent"> Advertisement Sent ? </label>
                                        <label class="switch">
                                            <input id="addword_sent" type="checkbox" v-model="advertisement.is_sent">
                                            <span class="switch__slider"></span>
                                        </label>  
                                    </div>
                                    <div>
                                        <label for="addword_sent"> Is Commission Based ? </label>
                                        <label class="switch">
                                            <input id="addword_sent" type="checkbox" v-model="advertisement.is_commission_based">
                                            <span class="switch__slider"></span>
                                        </label>  
                                    </div>
                                    <div v-if="!advertisement.is_commission_based">
                                        <label for="addword_cost">Advertisement Cost</label>
                                        <input id="addword_cost" 
                                                type="number" 
                                                step="0.01" 
                                                placeholder="Advertisement Cost" 
                                                v-model="advertisement.total_cost">
                                    </div>  
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 p-3">
                            <div class="col-md-4">
                                <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(40% - 1rem);">
                                    <label>Advertisement Image </label>
                                    <input id="file-upload" type="file" class="form-control" @change="uploadDoc($event,'advertisement')">
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 p-3">
                            <div class="col-md-3">
                                <label for="invoice_number">Invoice Number </label>
                                <input id="invoice_number" type="text" placeholder="Invoice Number" v-model="advertisement.invoice_number">
                            </div>
                            <div class="col-md-3">
                                <label for="invoice_amount">Invoice Total Amount</label>
                                <input id="invoice_amount" 
                                        type="number" 
                                        placeholder="Invoice Amount" 
                                        step="0.01"
                                        v-model="advertisement.invoice_amount"
                                        >
                            </div>
                            <div class="col-md-3">
                                <label for="payment_date">Due date</label>
                                <input id="payment_date" type="date" placeholder="Due date" v-model="advertisement.invoice_due_date">
                            </div>
                            <div class="col-md-3">
                                <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(40% - 1rem);">
                                    <label>Invoice PDF</label>
                                    <input id="file-upload" type="file" class="form-control" @change="uploadDoc($event,'invoice')" accept=".pdf">
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 p-3">
                            <div class="col-md-3">
                                <label for="payment_mode"> Payment mode </label>
                                <v-select
                                    id="payment_mode"
                                    :options="['Bax','Card','checque','cash','bank']"
                                    placeholder="Payment mode"
                                    v-model="advertisement.payment_mode"
                                    />
                            </div> 
                            <div class="col-md-3">
                                <label for="payment_number">Payment number</label>
                                <input id="payment_number" type="text" placeholder="Payment number" v-model="advertisement.payment_mode_number">
                            </div>
                            <div class="col-md-3">
                                <label for="paid_date"> Paid Date </label>
                                <input id="paid_date" type="date" placeholder="Paid date" v-model="advertisement.payment_date">
                            </div>
                            <div class="col-md-3">
                                <label for="paid_amount"> Paid Amount </label>
                                <input id="paid_amount" type="number" step="0.01" placeholder="Paid Amount" v-model="advertisement.payment_amount">
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                            <div class="form-wrap">
                                <div class="form-submit-inline">
                                    <button type="submit" class="button">
                                        <span> {{ (advertisement.flag === 'edit') ? 'Update' : 'Create' }} Advert </span>
                                    </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
    <!-- Advert Datatable -->
    <div class="box">
        <div class="row p-4">
            <div class="col-md-2">
                <div class="form-group">
                    <label class="form-label">By Size</label>
                    <select class="form-control" v-model="filters.advertisement_size">
                        <option value="">Select</option>
                        <option v-for="size in advertiseSizes" :key="size.size_id" :value="size.size_id">
                            {{ size.size_name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="row">
                    <div class="col-md-12">
                        <h6>Deadline Date Range</h6>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-6">
                        <dateTimePicker
                            no-label
                            label="From Date"
                            id="departureDateRangeStart"
                            format="YYYY-MM-DD"
                            formatted="YYYY-MM-DD"
                            button-color="#ec391e"
                            color="#ec391e"
                            :only-date="true"
                            v-model="filters.submission_deadline_date.from"
                            style="border: 1px solid #DFE5F9"
                        />
                    </div>
                    <div class="col-md-6">
                        <dateTimePicker
                            no-label
                            label="To Date"
                            id="departureDateRangeEnd"
                            format="YYYY-MM-DD"
                            formatted="YYYY-MM-DD"
                            button-color="#ec391e"
                            color="#ec391e"
                            :only-date="true"
                            v-model="filters.submission_deadline_date.to"
                            :min-date="filters.submission_deadline_date.from"
                            style="border: 1px solid #DFE5F9"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="row">
                    <div class="col-md-12">
                        <h6>Placement Date Range</h6>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-6">
                        <dateTimePicker
                            no-label
                            label="From Date"
                            id="departureDateRangeStart"
                            format="YYYY-MM-DD"
                            formatted="YYYY-MM-DD"
                            button-color="#ec391e"
                            color="#ec391e"
                            :only-date="true"
                            v-model="filters.placemenet_date.from"
                            style="border: 1px solid #DFE5F9"
                        />
                    </div>
                    <div class="col-md-6">
                        <dateTimePicker
                            no-label
                            label="To Date"
                            id="departureDateRangeEnd"
                            format="YYYY-MM-DD"
                            formatted="YYYY-MM-DD"
                            button-color="#ec391e"
                            color="#ec391e"
                            :only-date="true"
                            v-model="filters.placemenet_date.to"
                            :min-date="filters.placemenet_date.from"
                            style="border: 1px solid #DFE5F9"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="row">
                    <div class="col-md-12">
                        <h6>Invoice Due Date Range</h6>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-6">
                        <dateTimePicker
                            no-label
                            label="From Date"
                            id="departureDateRangeStart"
                            format="YYYY-MM-DD"
                            formatted="YYYY-MM-DD"
                            button-color="#ec391e"
                            color="#ec391e"
                            :only-date="true"
                            v-model="filters.invoice_due_date.from"
                            style="border: 1px solid #DFE5F9"
                        />
                    </div>
                    <div class="col-md-6">
                        <dateTimePicker
                            no-label
                            label="To Date"
                            id="departureDateRangeEnd"
                            format="YYYY-MM-DD"
                            formatted="YYYY-MM-DD"
                            button-color="#ec391e"
                            color="#ec391e"
                            :only-date="true"
                            v-model="filters.invoice_due_date.to"
                            :min-date="filters.invoice_due_date.from"
                            style="border: 1px solid #DFE5F9"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-1 mt-4">
                <button class="button" @click="filterAdverts">
                    <span> Filter</span>
                </button>
                <button class="button" @click="resetFilters">
                    <span><i class="icon icon--reload"></i></span>
                </button>
            </div>
        </div>
        <hr/>
        <div class="row mt-3">
            <div class="col-md-12">
                <vdtnet-table
                    ref="table"
                    :fields="fields"
                    :opts="options"
                    :key="advertKey"
                    @handleAdvertisementArtwork="handleAdvertisementArtwork"
                    @editAdvertisement="editAdvertisement"
                    @deleteAdvertisement="deleteAdvertisement"
                    @downloadGraphic="downloadGraphic"
                    @downloadInvoice="downloadInvoice"
                />
            </div>
        </div>
    </div>
    <!-- Advert Datatable -->


    <div class="modal__bg" v-if="showArtworkPaymentModal == true"></div>
            <div class="modal" v-if="showArtworkPaymentModal == true">
                <AdvertisementInvoices :advertiseSizes="advertiseSizes"
                :affiliateName="affiliate.name"
                :affiliateID="affiliateID"        
                :products="products" 
                :advertisement="selectedAdvertisement"
                @syncProducts="syncProducts"   />
                <button type="button" class="icon icon--unlink" v-on:click="showArtworkPaymentModal = false">Close</button>
            </div>
        <div class="modal__bg" v-if="showArtworkPaymentModal == true"></div>
</div>
</template>

<script>
import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'
import moment from 'moment';

import AdvertisementInvoices from '@/components/Affiliate/AdvertisementInvoices'

export default {
    name: 'AffiliateAdvertisement',
    props: {
        affiliateID:Number,
        advertiseSizes:Array,
        advertisements: Array,
        affiliate:Object,
    },
    components: {
        AdvertisementInvoices,
        VdtnetTable  
    },
    mounted() {
        setTimeout(() => {
            this.downloadInvoice()
            this.downloadArtwork (this.$route.query.downloadInvoice, null, 'invoice')
            if (this.$route.query.advertisement_id) {
                let self = this
                self.$store.dispatch('setLoadStatus')
                this.getAdvertisement(this.$route.query.advertisement_id)
                    .then((respopnse) => {
                        self.advertisement = {
                            flag: 'edit',
                            advertisement_id: this.$route.query.advertisement_id,
                            advertisement_size : Number(respopnse.advertisement_size),
                            placemenet_date : respopnse.placemenet_date,
                            expiry_date : respopnse.expiry_date,
                            total_cost : respopnse.total_cost,
                            submission_deadline_date : respopnse.submission_deadline_date,
                            is_graphic_created: respopnse.is_graphic_created,
                            is_sent: respopnse.is_sent,
                            invoice_number: respopnse.invoice_number,
                            invoice_amount: respopnse.invoice_amount,
                            invoice_due_date: respopnse.invoice_due_date,
                            payment_mode : respopnse.payment_mode,
                            payment_mode_number : respopnse.payment_mode_number,
                            payment_date : respopnse.payment_date,
                            payment_amount: respopnse.payment_amount,
                            is_commission_based: respopnse.is_commission_based,
                            commission_generated: respopnse.commission_generated
                        }
                        self.advertKey++
                    }).finally(() => {
                        self.$store.dispatch('setLoadStatus')
                    })
                
            }
        }, 1000);


    },
    data () {
        return {
            advertKey: 0,
            showArtworkPaymentModal:false,
            advertisement: {
                flag:'add'
            },
            products: [],
            selectedAdvertisement: null,
            fields: {
                advertisement_size: {
                    label: 'Size',
                    render: (data, type, row) => {
                        return row.advertise_size ? row.advertise_size.size_name : '-';
                    }
                },
                submission_deadline_date: {
                    label: 'Deadline',
                    render: (data, type, row) => {
                        return moment(String(data)).format('DD/MM/YYYY');
                    }
                },
                placemenet_date: {
                    label: 'Placement',
                    render: (data) => moment(String(data)).format('DD/MM/YYYY')
                },
                expiry_date: {
                    label: 'Expiry',
                    render: (data) => moment(String(data)).format('DD/MM/YYYY')
                },
                total_cost: {
                    label: 'Cost',
                    render: (data) => Number(data) ? Number(data).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }) : '-'
                },
                invoice_number: {
                    label: 'Invoice',
                    render: (data, type, row) => {
                        if (row.invoice_number) {
                            return `<a href="javascript:void(0)" class="color-orange" data-action="downloadInvoice">${row.invoice_number}</a>`;
                        }
                        return '-';
                    }
                },
                invoice_amount: {
                    label: 'Amount',
                    render: (data) => Number(data) ? Number(data).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }) : '-'
                },
                invoice_due_date: {
                    label: 'Due',
                    render: (data) => (data) ? moment(String(data)).format('DD/MM/YYYY'):'--'
                },
                is_commission_based: {
                    label: 'Commission',
                    render: (data) => data ? '<span class="badge badge-success">Yes</span>' : '<span class="badge badge-danger">No</span>'
                },
                paid_status: {
                    label: 'Paid',
                    render: (data, type, row) => {
                        return row.paid_status ? '<span class="badge badge-success">Yes</span>' : '<span class="badge badge-danger">No</span>';
                    }
                },
                is_graphic_created: {
                    label: 'Created',
                    render: (data) => data ? '<span class="badge badge-success">Yes1</span>' : '<span class="badge badge-danger">No</span>'
                },
                is_sent: {
                    label: 'Sent',
                    render: (data) => data ? '<span class="badge badge-success">Yes</span>' : '<span class="badge badge-danger">No</span>'
                },
                advertisement_id: {
                    label: 'Action',
                    render: (data, type, row) => {
                        let productBtn=''
                        let downloadBtn = ''
                        let editBtn=''
                        let deleteBtn=''

                        productBtn = `<a href="javascript:void(0)" 
                            class="btn btn-outline-warning" 
                            data-action="handleAdvertisementArtwork"
                            title="Products">
                                <span class="icon icon--products"></span>        
                            </a>`

                        if (row.graphic_name) {
                        downloadBtn= `
                            <a href="javascript:void(0)" class="btn btn-outline-primary" title="${row.graphic_name}" data-action="downloadGraphic">
                                <span class="icon icon--download"></span>
                            </a>`;
                        }
                        editBtn = `<a href="javascript:void(0)" class="icon icon--more" data-action="editAdvertisement" data-id="${row.advertisement_id}">Edit</a>`
                        deleteBtn = `<a href="javascript:void(0)" class="icon icon--delete" data-action="deleteAdvertisement" data-id="${row.advertisement_id}">Delete</a>`

                        return `${productBtn}
                            ${downloadBtn}
                            ${editBtn}
                            ${deleteBtn}`;
                    }
                }
            },
            options: {
                ajax: {
                    url: `${this.$api}affiliates/${this.$route.params.id}/adverts`,
                    data: (d) => {
                        // Add custom filter data to the request
                        d.selected_advertisement_id = this.advertisement.advertisement_id || null;
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                order: [[2, 'desc']],
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: true,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [5, 25, 50, 100, 500], [5, 25, 50, 100, 500] ],
                pageLength: 25,
                select: {
                    style: 'multi'
                },
                createdRow: (row, data) => {
                   $(row).addClass(`advert-row-${ data.advertisement_id}`);
                },
                drawCallback: (settings) => {
                    // Re-apply highlighting after table redraw
                    if (this.advertisement.advertisement_id) {
                        $(`.advert-row-${this.advertisement.advertisement_id}`).addClass('highlighted-row');
                    }
                },
            },
            filters: {
                advertisement_size: "",
                submission_deadline_date: {
                    from: null,
                    to: null
                },
                placemenet_date: {
                    from: null,
                    to: null
                },
                expiry_date: {
                    from: null,
                    to: null
                },
                invoice_due_date: {
                    from: null,
                    to: null
                }
            }
        }
    },
    methods: {
        uploadDoc(event, type) {
            if (type == 'invoice') {
                this.advertisement.invoice_file = event.target.files[0];
            } else {
                this.advertisement.artwork_file = event.target.files[0];
            }
        },
        recordAdvertisement() {
            let self = this
            self.$store.dispatch('setLoadStatus')
            let formData = new FormData();

            // Iterate through the object
            for (const key in self.advertisement) {
                // Check if the property belongs to the object (not inherited)
                if (self.advertisement.hasOwnProperty(key) && self.advertisement[key]) {
                    // Append key-value pair to the FormData object
                    formData.append(key, self.advertisement[key]);
                }
            }
            
            fetch(`${self.$api}affiliates/advertisement/${self.affiliateID}/submit`, {
                method: 'POST',
                body: formData,
                headers:{
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                self.errors = response.errors
                if(response.status) {
                    self.$notify({
                        type: 'success',
                        title: response.message
                    });
                    self.advertisement = {
                        flag:'add',
                    }
                    self.selectedAdvertisement = null
                    this.advertKey++
                } else if (response.errors) {
                    self.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                self.$store.dispatch('setLoadStatus')
            });

        },
        editAdvertisement(advertisement){
            let self = this
            self.$store.dispatch('setLoadStatus')
            this.getAdvertisement(advertisement.advertisement_id)
                .then((respopnse) => {
                    self.advertisement = {
                        flag: 'edit',
                        advertisement_id: advertisement.advertisement_id,
                        advertisement_size : Number(respopnse.advertisement_size),
                        placemenet_date : respopnse.placemenet_date,
                        expiry_date : respopnse.expiry_date,
                        total_cost : respopnse.total_cost,
                        submission_deadline_date : respopnse.submission_deadline_date,
                        is_graphic_created: respopnse.is_graphic_created,
                        is_sent: respopnse.is_sent,
                        invoice_number: respopnse.invoice_number,
                        invoice_amount: respopnse.invoice_amount,
                        invoice_due_date: respopnse.invoice_due_date,
                        payment_mode : respopnse.payment_mode,
                        payment_mode_number : respopnse.payment_mode_number,
                        payment_date : respopnse.payment_date,
                        payment_amount: respopnse.payment_amount,
                        is_commission_based: respopnse.is_commission_based,
                        commission_generated: respopnse.commission_generated
                    }
                    self.advertKey++
                }).finally(() => {
                    self.$store.dispatch('setLoadStatus')
                })
        },
        deleteAdvertisement (advertisement) {
            this.$dialog
            .confirm(`Are you sure you want to delete this advertisement ?`)
            .then(() => {
                this.$store.dispatch('setLoadStatus')
                fetch(`${this.$api}affiliates/advertisement/${this.affiliateID}/delete`, {
                    method: 'POST',
                    body: JSON.stringify({
                        advertisement_id: advertisement.advertisement_id
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.status) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                        this.$emit('handle-new-advertisements', response.advertisements)
                    } else if (response.errors) {
                        this.$notify({
                            type: 'error',
                            title: response.message
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            title: response.Error
                        });
                    }
                    this.$store.dispatch('setLoadStatus')
                });
            }).catch(() => {
                this.$store.dispatch('setLoadStatus')
                console.log('Clicked on cancel');
            });
        },  
        downloadGraphic(advertisement) {
            this.downloadArtwork(advertisement.advertisement_id, advertisement.graphic_name, 'graphic')
        },
        downloadInvoice(advertisement = null) {
            if (advertisement) {
                this.downloadArtwork(advertisement.advertisement_id, advertisement.invoice_name, 'invoice')
            }
        },
        downloadArtwork(advertisement_id = null, invoice_name = null, downloadFor = null) {
            if (!advertisement_id) {
                return false;
            }
            this.$store.dispatch('setLoadStatus')
            
            fetch(`${this.$api}affiliates/download-artwork/${advertisement_id}`, {
                method: 'POST',
                body: JSON.stringify({
                    download_type:downloadFor
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then((res) => {
            if(res.status === 200) {
                this.$store.dispatch('setLoadStatus')
                res.blob().then(response => {
                    const _url = window.URL.createObjectURL(response)
                    const link = document.createElement('a')
                    link.href = _url
                    link.setAttribute('download', (invoice_name) ? invoice_name : 'Artwork-Invoice.pdf')
                    document.body.appendChild(link)
                    link.click();
                })
            } else {
                this.$store.dispatch('setLoadStatus')
                Promise.race([res.json()])
                .then(response => {
                if(response.message) {
                    this.$notify({
                    type: 'error',
                    title: response.message
                    });
                } else {
                    this.$notify({
                    type: 'error',
                    title: response.error
                    });
                }
                })
            }
            });
        },
        handleAdvertisementArtwork(advertisement) {
            let self = this
            self.$store.dispatch('setLoadStatus')
            this.getAdvertisement(advertisement.advertisement_id)
                .then((respopnse) => {
                    console.log(respopnse);
                    self.selectedAdvertisement = respopnse
                    self.products = respopnse.products
                    self.showArtworkPaymentModal = true
                }).finally(() => {
                    self.$store.dispatch('setLoadStatus')
                })
        },
        getAdvertisement(advertisement_id) {
            return new Promise((resolve, reject) => {
                fetch(`${this.$api}affiliates/${this.affiliateID}/advert-detail/${advertisement_id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    if (response.status) {
                        resolve(response.data)
                    } else {
                        reject(response.message)
                    }
                })
                .catch(error => reject(error))
            });
        },
        filterAdverts() {
            const ajaxUrl = `${this.$api}affiliates/${this.$route.params.id}/adverts`
            const queryString = new URLSearchParams();

            if(this.filters.advertisement_size){
                queryString.set('advertisement_size', this.filters.advertisement_size);
            }

            if(this.filters.submission_deadline_date.from && this.filters.submission_deadline_date.to){
                queryString.set('submission_deadline_date_from', this.filters.submission_deadline_date.from);
                queryString.set('submission_deadline_date_to', this.filters.submission_deadline_date.to);
            }

            if(this.filters.placemenet_date.from && this.filters.placemenet_date.to){
                queryString.set('placemenet_date_from', this.filters.placemenet_date.from);
                queryString.set('placemenet_date_to', this.filters.placemenet_date.to);
            }

            if(this.filters.expiry_date.from && this.filters.expiry_date.to){
                queryString.set('expiry_date_from', this.filters.expiry_date.from);
                queryString.set('expiry_date_to', this.filters.expiry_date.to);
            }

            if(this.filters.invoice_due_date.from && this.filters.invoice_due_date.to){
                queryString.set('invoice_due_date_from', this.filters.invoice_due_date.from);
                queryString.set('invoice_due_date_to', this.filters.invoice_due_date.to);
            }

            const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;
            this.options.ajax.url = urlWithParams;
            this.advertKey++;
        },
        resetFilters() {
            this.filters = {
                advertisement_size: "",
                submission_deadline_date: {
                    from: null,
                    to: null
                },
                placemenet_date: {
                    from: null,
                    to: null
                },
                expiry_date: {
                    from: null,
                    to: null
                },
                invoice_due_date: {
                    from: null,
                    to: null
                }
            };
            this.options.ajax.url = `${this.$api}affiliates/${this.$route.params.id}/adverts`;
            this.advertisement = {
                flag:'add'
            }
            this.advertKey++;
        },
        syncProducts (productObject) {
            this.products = productObject
        },
    }
}
</script>

<style lang="scss" scoped>
.reload-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 2px solid #ec391e;
  color: #ec391e;
  border-radius: 50px;
  padding: 0.4em 0.8em;
  cursor: pointer;
  transition: background 0.3s, transform 0.2s, box-shadow 0.3s;
  box-shadow: 0 2px 8px rgba(236,57,30,0.08);

  &:hover {
    background: #ec391e;
    color: #fff;
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(236,57,30,0.18);

    .icon--reload {
      animation: spin 0.7s linear;
    }
  }
}

.icon--reload {
  font-size: 1.2em;
  margin-left: 0.2em;
  transition: color 0.3s;
}

@keyframes spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}

::v-deep .highlighted-row {
  background-color: #4477fb63 !important;
  border-left: 4px solid #ec391e !important;
  --bs-table-accent-bg: #ffe8a1 !important;
}

::v-deep .highlighted-row:hover {
  background-color: #4477fb63 !important;
}

</style>